import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Stack, Table } from "react-bootstrap";
import { useNavigate } from 'react-router-dom'
import inventoryApi from "../api/inventoryApi";

import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader
} from 'react-bs-datatable';
import { Link } from "react-router-dom";

import moment from "moment"

const StaffMemberList = () => {


  const navigate = useNavigate();
  const [body, setBody] = useState([]);
  /**
   * RMKM Phase 2 Changes
   * added by @ali 
   * date : 10 April 2025
   * Added filter state & enhanced code to fetch data according to filter 
   *  */
  const [filterOption, setFilterOption] = useState(null);

  // @Ayush - 11 September 2025, added service category filter
  const [serviceCategory, setServiceCategory] = useState([]);
  const [filteredServiceCategory, setFilteredServiceCategory] = useState([]);

  useEffect(() => {
    // Run once on mount
    getServiceCategory();
    getStaffMember(); // fetch initial staff
  }, []);

  useEffect(() => {
    // Run when filter changes
    if (filterOption) {
      getStaffMember(filterOption);
      filterServiceCategory();
    }
  }, [filterOption]);

  async function getStaffMember(filters) {
    const result = await inventoryApi.fetchStaffMember(filters);
    if (result) {
      setBody(result);
    } else {
      setBody([]);
    }
  }


  async function getServiceCategory() {
    const result = await inventoryApi.fetchServiceArea();
    if (result) {
      setServiceCategory(result);
    }
  }

  const filterServiceCategory = () => {
    if (filterOption?.servicearea) {
      let tempArray = serviceCategory.length && serviceCategory.filter(item => item.servicearea === filterOption.servicearea);
      setFilteredServiceCategory(tempArray);
    } else {
      setFilteredServiceCategory([]);
    }
  }

  // Create table headers consisting of 4 columns.
  const header = [
    {
      title: 'Username', prop: 'username', isFilterable: true,
      cell: (row) => (
        <Link
          to={"/staffmembers/" + row.id}
          state={row}
        >
          {row.username}
        </Link>
      )
    },
    { title: 'Email', prop: 'email', isFilterable: true },
    { title: 'Phone', prop: 'phone', isFilterable: true },
    { title: 'DOB', prop: 'dob', isFilterable: true, cell: (row) => moment(row.dob).format('MM/DD/YYYY'), },
    { title: 'Gender', prop: 'gender', isFilterable: true },
    { title: 'City', prop: 'city', isFilterable: true },
    { title: 'User Role', prop: 'userrole', isFilterable: true },
    { title: 'Service Area', prop: 'servicearea', isFilterable: true },
    // 17-04-2026 Added By Jaseem.
    // Show category label from API (servicecategoryname); fallback to raw id for older responses or missing join.
    // {/* RMKM AMC CHANGES POINT  */}
    {
      title: 'Service Category',
      prop: 'servicecategoryname',
      isFilterable: true,
      cell: (row) => row.servicecategoryname || row.servicecategory || '—',
    },
    { title: 'User Type', prop: 'usertype', isFilterable: true },



  ];

  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const labels = {
    beforeSelect: " "
  }

  const createStaffMember = () => {
    navigate(`/staffmembers/e`);
  }
  /**
   * RMKM Phase 2 Changes
   * added by @ali 
   * date : 10 April 2025
   * Create handler for filter state
   *  */
  const handleFilterChange = (e) => {
    e.target.name === 'servicearea' && setFilterOption((prev) => ({ ...prev, ['usertype']: '' }));
    setFilterOption((prev) => ({ ...prev, [e.target.name]: e.target.value }));

    // @Ayush - 11 September 2025, added service category filter
    if (e.target.name != 'servicecategory') {
      setFilterOption((prev) => ({ ...prev, ['servicecategory']: '' }));
    }
  }

  return (
    <Row className="g-0">
      <Col lg={2} className="mx-2">
        <Link className="nav-link">Home <i class="fa-solid fa-chevron-right"></i> Staff Member</Link>
      </Col>
      <Col lg={12} className="p-lg-4">

        {body ?
          <DatatableWrapper body={body} headers={header} paginationOptionsProps={{
            initialState: {
              rowsPerPage: 20,
              options: [5, 10, 15, 20]
            }
          }}>
            <Row className="mb-4 align-items-end">
              <Col
                xs={12}
                lg={3}
              // className="d-flex flex-col justify-content-end align-items-end"
              >
                <Filter />
              </Col>
              <Col
                xs={12}
                sm={6}
                lg={2}
              // className="d-flex flex-col justify-content-start align-items-start"
              >
                <PaginationOptions labels={labels} />

              </Col>
              {/**
             * RMKM Phase 2 Changes
             * added by @ali 
             * date : 10 April 2025
             * Added filter for users by Branch(servicearea) and by Position(usertype)
             **/
              }
              <Col
                xs={12}
                sm={6}
                lg={4}
              >
                <Stack direction="horizontal" gap={3}>
                  <Form.Select
                    aria-label="Enter Service Area"
                    name="servicearea"
                    value={filterOption?.servicearea || ''}
                    onChange={handleFilterChange}
                  >
                    <option value="">-- Select Branch --</option>
                    <option value="School">School </option>
                    <option value="CBR">CBR</option>
                    <option value="Day Care">Day Care</option>
                  </Form.Select>
                  {/* @Ayush - 11 September 2025, added service category filter */}
                  <Form.Select
                    aria-label="Enter Service Category"
                    name="servicecategory"
                    value={filterOption?.servicecategory || ''}
                    onChange={handleFilterChange}
                    disabled={filterOption?.servicearea === "" || filterOption === null}
                  >
                    <option value="">-- Select Category --</option>
                    {
                      filteredServiceCategory && filteredServiceCategory.map((item, index) => (
                        <option value={item.id} key={index}>{item.name}</option>
                      ))
                    }
                  </Form.Select>
                  <Form.Select
                    name="usertype"
                    value={filterOption?.usertype || ''}
                    onChange={handleFilterChange}
                    disabled={filterOption?.servicearea === ""}
                  >
                    <option value="">-- Select Position.--</option>
                    {filterOption?.servicearea === "CBR" && (
                      ["CBR Worker", "CMH", "CMM", "Physiotherapist", "Psychologist", "Speech Therapist", "Vocational Teacher"].map((value, index) => <option value={value} key={index}>{value}</option>)
                    )}
                    {filterOption?.servicearea === "School" && (
                      ["Centre In charge", "Special Educator", "Inclusive Teacher", "Physiotherapist", "Psychologist", "Speech Therapist", "Vocational Teacher"].map((value, index) => <option value={value} key={index}>{value}</option>)
                    )}
                    {filterOption?.servicearea === "Day Care" && (
                      ["Centre In charge", "Special Educator", "Inclusive Teacher", "Physiotherapist", "Psychologist", "Speech Therapist", "Vocational Teacher"].map((value, index) => <option value={value} key={index}>{value}</option>)
                    )}
                  </Form.Select>
                </Stack>
              </Col>
              <Col
                xs={12}
                sm={6}
                lg={3}
                className="d-flex flex-col justify-content-end align-items-end"
              >
                <Button className="btn-sm" variant="outline-primary" onClick={() => createStaffMember(true)}>Create Staff Member</Button>

              </Col>
            </Row>
            <Table striped className="data-table">
              <TableHeader />
              <TableBody />
            </Table>
            <Pagination />

          </DatatableWrapper> : ''}
      </Col>
      <Col lg={2}></Col>
    </Row>
  );
};

export default StaffMemberList;

